// extracted by mini-css-extract-plugin
export var img = "hero-module--img--1ef48";
export var wrap = "hero-module--wrap--f425b";